import { render, staticRenderFns } from "./navigationlessLayout.vue?vue&type=template&id=c85aef64"
import script from "./navigationlessLayout.vue?vue&type=script&lang=ts"
export * from "./navigationlessLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports